import moveToMenuStore from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Resets NewFolderViewState
 */
export default mutatorAction('resetNewFolderViewState', function resetNewFolderViewState() {
    moveToMenuStore.newFolderViewState = null;
});
//# sourceMappingURL=resetNewFolderViewState.js.map